module.exports = __webpack_public_path__ + "img/Button _QR_TC2.bcdff63e.png";